import type { AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { normalizeError } from '../error-handler';
import {
  shouldRetry,
  getRetryDelay,
  getRetryConfig,
  incrementRetryCount,
} from '../retry-config';
import axios from 'axios';

export function responseInterceptor(response: AxiosResponse): AxiosResponse {
  return response;
}

export async function errorInterceptor(error: AxiosError): Promise<never> {
  const config = error.config as InternalAxiosRequestConfig;

  if (!config) {
    throw normalizeError(error);
  }

  const retryConfig = getRetryConfig(config);

  if (shouldRetry(error) && retryConfig.retryCount < retryConfig.retries) {
    incrementRetryCount(config);
    const delay = getRetryDelay(retryConfig.retryCount, retryConfig.retryDelay);

    await new Promise(resolve => setTimeout(resolve, delay));

    return axios.request(config);
  }

  throw normalizeError(error);
}
